import { getInitData } from './telegram';

const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

// Closed set of event names accepted by POST /api/v1/miniapp/track. Mirrors
// the Go-side allowlist in pkg/analytics/events.go — adding a new event means
// updating both. The string-literal union keeps callers honest at compile
// time so a typo can't silently fall back to "unknown_event" 400 in prod.
export type MiniappEvent =
  | 'miniapp_opened'
  | 'miniapp_paywall_viewed'
  | 'miniapp_invoice_opened'
  | 'miniapp_setup_completed'
  | 'miniapp_happ_link_opened';

// Properties are flat scalars only; the server rejects nested objects. Match
// that shape on the client too so a misuse fails locally rather than 400-ing
// at the edge.
export type TrackProps = Record<string, string | number | boolean>;

// track is fire-and-forget. Never awaited, never throws to the caller —
// analytics outages must not affect the user-facing flow. The auth header
// reuses the same `tma <initData>` scheme as the rest of /miniapp/* so the
// server stamps the authenticated telegram_id rather than trusting the
// client.
export function track(event: MiniappEvent, properties?: TrackProps): void {
  const initData = getInitData();
  if (!initData) {
    // No verified Telegram session — the endpoint would 401 anyway. Drop
    // silently so opening the miniapp in a plain browser (local dev) doesn't
    // spam the network tab.
    return;
  }

  const body = JSON.stringify(properties ? { event, properties } : { event });

  // keepalive lets the request survive a navigation away (tab close, deeplink
  // out to CryptoBot/happ). Without it, the last event before navigating
  // would be cancelled mid-flight and never reach NR.
  fetch(`${API_BASE}/api/v1/miniapp/track`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `tma ${initData}`,
    },
    body,
    keepalive: true,
  }).catch((err) => {
    if (import.meta.env.DEV) {
      console.warn('[analytics] track failed', event, err);
    }
  });
}
